export const HOME = {
  emergentLink: "emergent-link",
  navSignIn: "nav-sign-in",
  navBrand: "nav-brand",
  valueProp: "value-prop",
  heroEyebrow: "hero-eyebrow",
  heroHeadline: "hero-headline",
  ideaInput: "idea-input",
  ideaSubmit: "idea-submit",
  categoryPill: "category-pill",
  featureCard: "feature-card",
  howItWorksStep: "how-it-works-step",
};

export const BLUEPRINT = {
  loader: "blueprint-loader",
  page: "blueprint-page",
  title: "blueprint-title",
  tagline: "blueprint-tagline",
  section: "blueprint-section",
  moodboardImage: "blueprint-moodboard-image",
  ctaRequestQuote: "blueprint-request-quote",
  ctaBookCall: "blueprint-book-call",
  ctaBack: "blueprint-back",
  quoteModal: "quote-modal",
  quoteName: "quote-name",
  quoteEmail: "quote-email",
  quotePhone: "quote-phone",
  quoteNotes: "quote-notes",
  quoteSubmit: "quote-submit",
  quoteSuccess: "quote-success",
};
